<div class="card-group">
    
    <ng-container *ngIf="values[0]">
        <div *ngFor="let value of values" class = "mr-3 ml-3">
            <div class="card mt-3">
                <h5 class="card-header">{{value.organization}}</h5>
                <div class="card-body">
                    <h5 class="card-title"><span translate>text_card.site</span> {{value.siteName}}</h5>
                    <h5 class="card-title"><span translate>text_card.counter</span> {{value.counterName}}</h5>
                    <p class="card-text" translate>text_card.info</p>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf = "!values[0] && operatorId">
        <div class = "mr-3 ml-3">
            <div class="card mt-3">
                <h5 class="card-header"><span translate>text_card.no_counter</span></h5>
                <div class="card-body">
                    <h5 class="card-title"><span translate>text_card.no_counter_info</span></h5>
                </div>
            </div>
        </div>
    </ng-container>

</div>